export default{
    // Login
    // Signup
    // Quotation Process

    select_insurance_class: "Please Select an insurance Class",
    select_product: "Please select a product to proceed"
    // Claim Process
}